<template>
  <div></div>
</template>

<script>
export default {
  watch: {
    $route(to) {
      // When the route page query changes, query for new data
      const page = to.query.page || 1;
      this.queryData(page);
    }
  },
  methods: {
    pageChanged(page) {
      this.$router.push({ name: this.$route.name, query: { page: page } });
    },
    queryData() {
      // A stub to be overriden by whichever page extends this one
    }
  },
  mounted() {
    const page = this.$route.query.page || 1;
    this.queryData(Number.parseInt(page));
  }
};
</script>
